const pad = value => String(value).padStart(2, '0')

export const DATE_FORMAT_LABEL = 'YYYY-MM-DD'
export const DATE_TIME_FORMAT_LABEL = 'YYYY-MM-DD HH:mm'

export function formatDate (value, fallback = '—') {
  if (!value) return fallback
  if (typeof value === 'string') {
    const match = value.match(/^(\d{4}-\d{2}-\d{2})/)
    if (match) return match[1]
  }

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return fallback
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export function formatDateTime (value, fallback = '—') {
  if (!value) return fallback

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return fallback
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}
